import { LocalStorage as SessionStorage } from 'quasar'

export function setFormStep(state, step) {
    state.step = step
    // if (step == 1) {
    //     state.registration_code = null
    // }
}

export function setRoleName(state, role_name) {
    state.role_name = role_name
}

export function setUserInfo(state, payload) {
    state.email_look_up = true
    state._id = payload._id ? payload._id : ''
    state.email = payload.email ? payload.email : ''
    state.f_name = payload.f_name ? payload.f_name : ''
    state.l_name = payload.l_name ? payload.l_name : ''
    state.country = payload.country ? payload.country : ''
    state.city = payload.city ? payload.city : ''
    state.phone = payload.mob_no ? payload.mob_no : ''
    state.university = payload.university ? payload.university : ''
    state.degree = payload.degree ? payload.degree : ''
    state.company = payload.company ? payload.company : ''
    state.employer = payload.company ? payload.company : ''
    state.employerIsReadOnly = payload.company ? true : false
    state.title = payload.job_title ? payload.job_title : ''
    state.department_id = payload.department_id ? payload.department_id : ''
    state.company_role_id = payload.company_role_id ? payload.company_role_id : ''
}

export function setCompanyInfo(state, payload) {

    if(payload.company){
        if(payload.company_roles.length > 0) {
            state.company = payload.company
            state.roles = payload.company_roles
            state.departments = payload.departments
            state.role_name = "Student"
        }else{
            state.company = payload.company
            state.roles = []
            state.role_name = "Student_Coachees"
        }
    }else{
      state.company = payload.company
      state.roles = payload.company_roles
      state.departments = payload.departments
      state.role_name = "Student"
    }

    if(payload.roles.length > 0) {
        if(payload.roles[0].name == 'Coach'){
            state.company = payload.company
            state.roles = payload.company_roles
            state.departments = payload.departments
            state.role_name = payload.roles[0].name
        }
    }

}


export function resetCompanyInfo(state) {
    state.company = ""
    state.roles = []
    state.departments = []
    state.role_name = ""
}

export function setUploadImageModal(state, payload) {
    state.uploadImageModal = payload
}

export function resetRegistrationCode(state) {
    state.registration_code = ""
}

export function resetStore(state) {
    // state.registration_code = ""
    state.email = ""
    state.otp = null
    state.terms_of_service = false
    state.university_student = false
    state.employee = false
    state.f_name = ""
    state.l_name = ""
    state.company = ""
    state.employer = ""
    state.title = ""
    state.company_role_id = ""
    state.university = ""
    state.degree = ""
    state.phone = ""
    state.std_code = ""
    state.birth_date = null
    state.birth_month = ""
    state.birth_year = null
    state.country = ""
    state.province = ""
    state.city = ""
    state.timezone = ""
    state.profile_image = null
    state.profile_photo = null
    state.profile_photo_base64 = null
    state.password = ""
    state.confirm_password = ""
    state.email_look_up = false
    state.emailLookUp = null
    state.step = 1
    state.roles = []
    state.role_name = ""
}
